var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentPayment.status == 'success')?_c('SuccessfulPayment',{attrs:{"payment":_vm.currentPayment}}):_c('FailedPayment',{attrs:{"payment":_vm.currentPayment}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }